"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FieldType;
(function (FieldType) {
    FieldType["BOOLEAN"] = "boolean";
    FieldType["COLLECTION"] = "collection";
    FieldType["COLOR"] = "color";
    FieldType["CURRENCY"] = "currency";
    FieldType["DATE"] = "date";
    FieldType["DURATION"] = "duration";
    FieldType["EMAIL"] = "email";
    FieldType["FILE"] = "file";
    FieldType["LENGTH"] = "length";
    FieldType["LIST"] = "list";
    FieldType["NAME"] = "name";
    FieldType["NUMBER"] = "number";
    FieldType["OCCUPATION"] = "occupation";
    FieldType["PERCENTAGE"] = "percentage";
    FieldType["PHONE"] = "phone";
    FieldType["PIPELINE"] = "pipeline";
    FieldType["TEXT"] = "text";
    FieldType["TYPE"] = "type";
    FieldType["URL"] = "url";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
